<form
  class="form-signin password"
  [formGroup]="verifyForm"
  *ngIf="verifyForm"
  (ngSubmit)="onSubmitVerify($event)"
  autocomplete="off"
>
  <h4>Réinitialisation du mot de passe</h4>
  <div
    class="alert"
    style="font-size: 0.8em; padding: 10px; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
  >
    Renseignez votre adresse email. Vous recevrez un email
    permettant la réinitialisation de votre mot de passe.
  </div>

  <input
    type="text"
    class="form-control"
    name="pseudo"
    formControlName="username"
    placeholder="Email"
    required
    autofocus
    [ngClass]="{ 'is-invalid': submitted && vf.username.errors }"
  />
  <div *ngIf="submitted && vf.username.errors" class="invalid-feedback">
    <div *ngIf="vf.username.errors.required">Email requis.</div>
  </div>

  <p class="alert-error" *ngIf="error">
    <i class="fas fa-exclamation-triangle icon-alert-error"></i> Vérifiez votre
    email.
  </p>

  <div class="col-12 text-center pt-4">
    <button class="btn btn-success" type="submit" [disabled]="loading">
      <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>&nbsp;<i
        class="fas fa-envelope"
      ></i>
      Envoyer le lien de réinitialisation
    </button>
  </div>

  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
  <div
    class="alert mt-3 mb-0"
    style="font-size: 0.8em; padding: 10px; cursor: pointer; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
    (click)="goToLogin()"
  >
    Vous connaissez votre mot de passe ? <strong>Cliquez-ici</strong>
  </div>

  <div class="col-12 text-center pt-4">
    <button class="btn" type="button" (click)="goBack()" style="background-color: #1f519e; color: white;">
      <i class="fa fa-chevron-left"></i> Retour
    </button>
  </div>
</form>


<form
  class="form-signin password"
  [formGroup]="passwordForm"
  *ngIf="passwordForm"
  (ngSubmit)="onSubmitReset($event)"
  autocomplete="off"
>
<ng-container *ngIf="user">
  <h4>Réinitialisation du mot de passe</h4>
  <div
    class="alert"
    style="font-size: 0.8em; padding: 10px; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
  >
    Renseignez votre nouveau mot de passe.
  </div>

  <input
    type="password"
    class="form-control"
    name="password"
    formControlName="password"
    placeholder="Mot de passe"
    required
    autofocus
    [ngClass]="{ 'is-invalid': submitted && pf.password.errors }"
  />
  <div *ngIf="submitted && pf.password.errors" class="invalid-feedback">
    <div >{{pf.password.errors | json}}</div>
    <div *ngIf="pf.password.errors.required">Mot de passe requis.</div>
  </div>
  <input
    type="password"
    class="form-control"
    name="confirmPassword"
    formControlName="confirmPassword"
    placeholder="Confirmation du mot de passe"
    required
    autofocus
    [ngClass]="{ 'is-invalid': submitted && pf.confirmPassword.errors }"
  />
  <div *ngIf="submitted && pf.confirmPassword.errors" class="invalid-feedback">
    <div *ngIf="pf.confirmPassword.errors.required">Confirmation du mot de passe requis.</div>
    <div *ngIf="pf.confirmPassword.errors.mustMatch">Les mots de passes doivent correspondre</div>
  </div>

  <p class="alert-error" *ngIf="error">
    <i class="fas fa-exclamation-triangle icon-alert-error"></i> Vérifiez votre
    mot de passe.
  </p>
  <span *ngIf="pf.confirmPassword.hasError('notSame')">Password do not match.</span>
  <div class="col-12 text-center pt-4">
    <button class="btn btn-success" type="submit" [disabled]="loading">
      <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>&nbsp;<i
        class="fas fa-sign-in-alt"
      ></i>
      Réinitialiser
    </button>
  </div>

  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
  </ng-container
  >
  <ng-container *ngIf="!user"><div class="alert" style="background-color: #fff3cd; border: 1px solid #f9b833; color: #333;">Ce lien est inactif, merci de recommencer la procédure de réinitialisation</div></ng-container>

  <div class="alert mt-3 mb-0" style="font-size: 0.8em; padding: 10px; cursor: pointer; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
   (click)="goToLogin(true)">Vous avez déjà un compte ? <strong>Cliquez-ici</strong></div>
  <div class="alert mt-3 mb-0" style="font-size: 0.8em; padding: 10px; cursor: pointer; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
  (click)="goToSignin(true)">Premiere connexion ? <strong>Cliquez-ici</strong></div>

  <div class="col-12 text-center pt-4">
    <button class="btn" type="button" (click)="goBack()" style="background-color: #1f519e; color: white;">
      <i class="fa fa-chevron-left"></i> Retour
    </button>
  </div>
</form>
